import React from 'react';
import PropTypes from 'prop-types';
import { GradientCard } from '../blocks/GradientCard';
import { CompactHeader } from '../blocks/CompactHeader';
import { QuestionPills } from '../blocks/QuestionPills';
import { SummaryPanel } from '../blocks/SummaryPanel';

/**
 * Two API questions and the ask-your-own pill, which is the two 44px pill rows the design's questions
 * column is built around — see `QuestionPills`.
 */
const MAX_QUESTIONS = 2;

export const VariantB = ({ questions, summary, onAskQuestion }) => {
  const { title, body } = summary || {};

  return (
    <GradientCard variant="variant-b">
      {/* The design fills 1296px with two 640px columns and a 16px gap. Equal halves is the
          responsive reading of that: the banner spans whatever width the PLP gives it. Padding is
          16px on the left because the rail already covers half the 32px inset — see `GradientCard`. */}
      <div
        id="ai-assisted-search-banner-body"
        data-testid="ai-assisted-search-banner-body"
        className={
          'sui-flex sui-grow sui-min-w-0 sui-flex-col lg:sui-flex-row sui-gap-4'
          + ' sui-pl-4 sui-pr-6 sui-py-6 lg:sui-pr-8 lg:sui-py-8'
        }
      >
        <div
          id="ai-assisted-search-banner-suggested-questions"
          data-testid="ai-assisted-search-banner-suggested-questions"
          className="sui-flex sui-flex-col sui-gap-4 sui-min-w-0 lg:sui-basis-1/2"
        >
          <CompactHeader />
          <QuestionPills
            questions={questions}
            maxQuestions={MAX_QUESTIONS}
            onAskQuestion={onAskQuestion}
          />
        </div>
        <div
          id="ai-assisted-search-banner-summary"
          data-testid="ai-assisted-search-banner-summary"
          className="sui-min-w-0 lg:sui-basis-1/2"
        >
          <SummaryPanel title={title} body={body} />
        </div>
      </div>
    </GradientCard>
  );
};

VariantB.displayName = 'VariantB';

VariantB.propTypes = {
  /** Questions for the pills. `text` is markdown. */
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.number.isRequired,
      text: PropTypes.string,
    })
  ),
  /** Called when a question is chosen. */
  onAskQuestion: PropTypes.func,
  /** `Summary` for the right column. `body` is markdown. */
  summary: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
  }),
};
